import React, { useState } from "react";
import "./BookWriting.css";

const pdfs = [
  { title: "English – Class 1", subject: "English", class: "1", file: "English-1.pdf" },
  { title: "English – Class 3", subject: "English", class: "3", file: "english 3.pdf" },
  { title: "English – Class 8", subject: "English", class: "8", file: "English-8.pdf" },
  { title: "Maths – Class 5", subject: "Maths", class: "5", file: "MATHS 5.pdf" },
  { title: "Hindi – Class 4", subject: "Hindi", class: "4", file: "hindi 4.pdf" },
  { title: "Hindi – Class 8", subject: "Hindi", class: "8", file: "Hindi-8_128 pages.pdf" },
  { title: "Science – Class 1", subject: "Science", class: "1", file: "Final Science_01.pdf" },
  { title: "Social Studies – Class 1", subject: "Social", class: "1", file: "SOCIAL 1.pdf" },
  { title: "Social Studies – Class 6", subject: "Social", class: "6", file: "Social Studies_6.pdf" },
  { title: "Sanskrit – Class 7", subject: "Sanskrit", class: "7", file: "Sanskrit-7 WEB.pdf" },
  { title: "Grammar", subject: "English", class: "-", file: "Grammar-2.pdf" },
];

const BookWriting = () => {
  const [previewPdf, setPreviewPdf] = useState(null);

  const downloadPdf = (file) => {
    const link = document.createElement("a");
    link.href = `/pdfs/${file}`;
    link.download = file;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="pdf-library">
      <h1>📚 Book Writing & Proofreading</h1>

      {pdfs.map((pdf, index) => (
        <div className="pdf-card" key={index}>
          <div className="pdf-info">
            <h3>📘 {pdf.title}</h3>
            <p>
              Subject: <b>{pdf.subject}</b> | Class: <b>{pdf.class}</b>
            </p>
          </div>

          <div className="pdf-actions">
            <button onClick={() => setPreviewPdf(pdf.file)}>👁 Preview</button>
            <button onClick={() => downloadPdf(pdf.file)}>⬇ Download</button>
          </div>
        </div>
      ))}

      {/* PREVIEW MODAL */}
      {previewPdf && (
        <div className="pdf-modal">
          <div className="pdf-modal-content">
            <button className="close-btn" onClick={() => setPreviewPdf(null)}>
              ✖
            </button>

            <iframe
              src={`/pdfs/${previewPdf}`}
              title="PDF Preview"
              frameBorder="0"
            ></iframe>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookWriting;
